import { thisHostAndBasePath } from '@/../config';

/**
 * Converts IBM Cloud Object Storage path-style URLs to virtual-hosted (subdomain) style.
 *
 * Path-style:    https://s3.us-east.cloud-object-storage.appdomain.cloud/<bucket>/<key>
 * Subdomain-style: https://<bucket>.s3.us-east.cloud-object-storage.appdomain.cloud/<key>
 *
 * The subdomain-style is required because path-style URLs return 404 in the staging environment.
 * Returns the URL unchanged if it is already in subdomain style or is not a COS URL.
 */
export function normalizeCosUrl(url: string | null | undefined): string | null | undefined {
  if (!url) return url;
  const pathStylePattern =
    /^https?:\/\/s3\.us-east\.cloud-object-storage\.appdomain\.cloud\/([^/]+)\/(.+)$/;
  const match = url.match(pathStylePattern);
  if (!match) return url;
  const [, bucket, key] = match;
  return `https://${bucket}.s3.us-east.cloud-object-storage.appdomain.cloud/${key}`;
}

/**
 * Normalizes champion profile image URLs by replacing spaces (and %20) with underscores
 * to match IBM Cloud Object Storage naming conventions.
 */
export function formatProfileImageUrl(url: string | null | undefined): string {
  if (!url) return '';
  try {
    const decoded = decodeURIComponent(url);
    const withUnderscores = decoded.replace(/\s+/g, '_');
    return encodeURI(withUnderscores);
  } catch {
    return encodeURI(url.replace(/%20/g, '_').replace(/\s+/g, '_'));
  }
}

export function appendHostAndBasePath(path: string): string {
  if (path.startsWith('/')) {
    return `${thisHostAndBasePath}${path}`;
  }
  return path;
}
export function validateBackslash(url: string): string {
  try {
    const urlObj = new URL(url);

    if (urlObj.search) {
      return url;
    }

    if (!urlObj.pathname.endsWith("/")) {
      urlObj.pathname += "/";
    }

    return urlObj.toString();
  } catch (error) {
    const hasQueryParams = url.includes("?");

    if (hasQueryParams) {
      return url;
    }

    return url.endsWith("/") ? url : url + "/";
  }
}